import { PlusIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'

import { getInitials } from './sidebar-org-switcher-helpers.util'

interface Organization {
  id: string
  name: string
  slug: string | null
  imageUrl: string | null
}

interface SidebarOrgSwitcherContentProps {
  organizations: Organization[]
  isMobile: boolean
  onOrganizationSelect: (orgId: string) => void
  onCreateOrganization: () => void
}

export const SidebarOrgSwitcherContent = ({
  organizations,
  isMobile,
  onOrganizationSelect,
  onCreateOrganization,
}: SidebarOrgSwitcherContentProps): ReactNode => (
  <DropdownMenuContent
    className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
    side={isMobile ? 'bottom' : 'right'}
    align="start"
    sideOffset={4}
  >
    <DropdownMenuLabel className="text-xs text-muted-foreground">Organizations</DropdownMenuLabel>
    {organizations.map((org) => (
      <DropdownMenuItem
        key={org.id}
        onClick={() => onOrganizationSelect(org.id)}
        className="gap-2 p-2"
      >
        <Avatar className="h-6 w-6 rounded-md">
          <AvatarImage src={org.imageUrl ?? undefined} alt={org.name} />
          <AvatarFallback className="rounded-md text-xs">{getInitials(org.name)}</AvatarFallback>
        </Avatar>
        <span className="truncate" title={org.name}>
          {org.name}
        </span>
      </DropdownMenuItem>
    ))}
    <DropdownMenuSeparator />
    <DropdownMenuItem onClick={onCreateOrganization} className="gap-2 p-2">
      <div className="flex h-6 w-6 items-center justify-center rounded-md border bg-background">
        <PlusIcon className="h-4 w-4" />
      </div>
      <span>Create Organization</span>
    </DropdownMenuItem>
  </DropdownMenuContent>
)
